import React from "react";

/**
 * Image SEO fields — Image Alt & Image Title for a single image.
 * Use stacked=true inside narrow gallery tiles.
 */
export function ImageSeoFields({
  imageAlt = "",
  imageTitle = "",
  onAltChange,
  onTitleChange,
  className = "",
  disabled = false,
  showHeading = true,
  stacked = false,
}) {
  return (
    <div className={`space-y-2 ${className}`}>
      {showHeading && (
        <p
          className={`font-semibold text-gray-800 ${
            stacked ? "text-[11px]" : "text-sm"
          }`}
        >
          Image SEO
        </p>
      )}
      <div
        className={
          stacked
            ? "flex flex-col gap-2"
            : "grid grid-cols-1 gap-3 sm:grid-cols-2"
        }
      >
        <div className="min-w-0">
          <label
            className={`mb-1 block font-medium text-gray-700 ${
              stacked ? "text-[10px]" : "text-sm"
            }`}
          >
            Image Alt
          </label>
          <input
            type="text"
            value={imageAlt || ""}
            onChange={(e) => onAltChange?.(e.target.value)}
            disabled={disabled}
            placeholder="Image alt text"
            className={`w-full rounded-md border border-gray-300 px-2 text-gray-800 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-100 ${
              stacked ? "py-1.5 text-xs" : "px-3 py-2 text-sm"
            }`}
          />
        </div>
        <div className="min-w-0">
          <label
            className={`mb-1 block font-medium text-gray-700 ${
              stacked ? "text-[10px]" : "text-sm"
            }`}
          >
            Image Title
          </label>
          <input
            type="text"
            value={imageTitle || ""}
            onChange={(e) => onTitleChange?.(e.target.value)}
            disabled={disabled}
            placeholder="Image title"
            className={`w-full rounded-md border border-gray-300 px-2 text-gray-800 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-100 ${
              stacked ? "py-1.5 text-xs" : "px-3 py-2 text-sm"
            }`}
          />
        </div>
      </div>
    </div>
  );
}

/** Append single-image SEO fields to FormData. */
export function appendImageSeoToFormData(formData, imageAlt, imageTitle) {
  if (imageAlt != null && String(imageAlt).trim()) {
    formData.append("image_alt", String(imageAlt).trim());
  }
  if (imageTitle != null && String(imageTitle).trim()) {
    formData.append("image_title", String(imageTitle).trim());
  }
}

/** Append prefixed SEO fields (e.g. header_image_alt). */
export function appendPrefixedImageSeoToFormData(
  formData,
  prefix,
  imageAlt,
  imageTitle,
) {
  if (imageAlt != null && String(imageAlt).trim()) {
    formData.append(`${prefix}_alt`, String(imageAlt).trim());
  }
  if (imageTitle != null && String(imageTitle).trim()) {
    formData.append(`${prefix}_title`, String(imageTitle).trim());
  }
}
